import { schemaScope } from "../scope.js";
export const tsKeywords = schemaScope({
    any: {},
    bigint: "bigint",
    // since we know this won't be reduced, it can be safely cast to a union
    boolean: [{ unit: false }, { unit: true }],
    false: { unit: false },
    never: [],
    null: { unit: null },
    number: "number",
    object: "object",
    string: "string",
    symbol: "symbol",
    true: { unit: true },
    unknown: {},
    void: { unit: undefined },
    undefined: { unit: undefined }
}, { prereducedAliases: true, registerKeywords: true }).export();
